const state = {
  user: false,
  users: [],
  user_api: '/api/v1/settings/users/',
    user_logs: [],
    logs_total: 0,
    logs_current: 0,
    logs_perpage: 0,
    search_user_logs:null
};

// getters
const getters = {
    getSearchUserLogs: (state) => {
        return state.search_user_logs;
    },
    getUserLogs: (state) => {
        return state.user_logs;
    },
    getLogsTotal: (state) => {
        return state.logs_total;
    },
    getLogsCurrent: (state) => {
        return state.logs_current;
    },
    getLogsPerPage: (state) => {
        return state.logs_perpage;
    },
  // Get User api
  getUserAPI: (state) => {
    // Return Users api
    return state.user_api;
  },

  // Get user
  getUsers: (state) => {
    // Return user
    return state.users;
  },
};

// mutations
const mutations = {
    setSearchUserLogs(state, search) {
        state.search_user_logs = search;
    },
    // Set users
    setUsers (state,payload){

        state.users = payload;
  },

    setLogsTotal (state, logs_total){
        state.logs_total = logs_total;
    },

    setLogsCurrent (state, logs_current){
        state.logs_current = logs_current;
    },

    setLogsPerPage (state, logs_perpage){
        state.logs_perpage = logs_perpage;
    },

    setUserLogs (state, user_logs){
        state.user_logs = user_logs;
    },
    // Set total
    setTotal (state, total){
        state.total = total;
    },

    // Set total
    setCurrent (state, current){
        state.current = current;
    },

    // Set per page
    setPerPage (state, perpage){
        state.perpage = perpage;
    },

    // Set notifications
    setNotifications (state, notifications){
        state.notifications = notifications;
    },

};

// actions
const actions = {

  // Fetch Users
  async fetchUsers({commit,dispatch, getters, state}){

      // Start waiting
      dispatch('wait/start', 'users', { root: true });

        // Get Users
      await axios.get(getters.getUserAPI)
            .then((response) => {
                 // Set Users
                    commit('setUsers', response.data);

                    // Stop waiting
                    dispatch('wait/end', 'users', { root: true });
            })
            .catch((error) => {

                // Show error
                Vue.toasted.error(Vue.i18n.translate('simple.error_info'));

                // Log to console
                console.log(error);

                // Stop waiting
                dispatch('wait/end', 'users', { root: true });

            });

    },
    async fetchUserLogs({ dispatch, commit, state, rootGetters}, {user_id, search= "", page = 1}){
        dispatch('wait/start', 'logs', { root: true });
        // Check if we have page set or set it to default?
        let current_page = page ? page : 1;
        const user_logs_api ='/api/v1/settings/users/';
        let api_params= "";
        if (search !== ""){
            api_params += `&search=${search}`
        }
        // Start waiting
        dispatch('clearPagination');
        await axios.get(`${user_logs_api + user_id}/logs?page=${page+api_params}`)
            .then((response) => {
                const user_logs = response.data.data.data.map(log => ({
                    changed_item: log.changed_item,
                    old_value: log.old_value,
                    new_value: log.new_value,
                    created_at: log.created_at,
                    user_name: log.user?.name ?? '',
                    team_name: log.team?.name ?? '',
                    changed_by_name: log.changed_by_user?.name ?? '',
                }));
                commit('setUserLogs', user_logs);
                commit('setLogsCurrent', response.data.data.current_page);
                commit('setLogsPerPage', response.data.data.per_page);
                commit('setLogsTotal', response.data.data.total);
            })
            .catch((error) => {
                // Show error
                Vue.toasted.error(Vue.i18n.translate('simple.error_info'));
                // Log to console
                console.log(error);
            });

        // Stop waiting
        dispatch('wait/end', 'logs', { root: true });
    },
    // Clear pagination data
    clearPagination({ dispatch, commit }) {

        // Set total to false
        commit('setLogsTotal', false);

        // Set current to false
        commit('setLogsCurrent', false);
        // Set per page to false
        commit('setLogsPerPage', false);

    },
    updateSearchUserLogs({commit},search){
        commit("setSearchUserLogs", search);
    },
    updateLogPage({ dispatch, commit, state }, data) {
        // Update confirmations
        dispatch('fetchUserLogs', data);

    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}